module.exports = __webpack_public_path__ + "static/EsmeraldaA-6474877da4a5b1318b60baf71f5ee6a4.gif";